import React from 'react';
import PropTypes from 'prop-types';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Skeleton from '@material-ui/lab/Skeleton';

const useStyles = makeStyles({
  text_spacing: {
    marginTop: '5px'
  },
  content_spacing: {
    marginTop: '10px'
  }
});

const WidgetSkeleton = ({ colSpan }) => {
  const classes = useStyles();

  return (
    <Grid item xs={12} md={colSpan}>
      <Box
        width="100%"
        p={2}
        boxShadow={2}
        borderTop={3}
        borderColor="#346C9F"
        minHeight="300px"
        height="100%"
      >
        <Skeleton variant="text" width="20%" animation="wave" />

        <Skeleton variant="text" width="40%" animation="wave" className={classes.text_spacing} />

        <Skeleton
          variant="rect"
          width="100%"
          animation="wave"
          className={classes.content_spacing}
          height={280}
        />
      </Box>
    </Grid>
  );
};

WidgetSkeleton.propTypes = {
  colSpan: PropTypes.number.isRequired
};

export default WidgetSkeleton;
